<form [formGroup]="drawCodeForm" (ngSubmit)="onFormSubmit()" autocomplete="off">
  <div class="row">
    <div class="col-sm-6">
      <input-field
        [label]="'Code'"
        [type]="'text'"
        [placeholder]="'Enter minor code'"
        formControlName="code"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Minor Code is required'"
      ></input-field>
    </div>
    <div class="col-sm-6">
      <input-field
        [label]="'Description'"
        [type]="'text'"
        [placeholder]="'Enter code description'"
        formControlName="description"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Description is required'"
      ></input-field>
    </div>
  </div>
</form>
